import { FC } from 'react';

import { SuccessWrapper } from 'common/components';
import { DownloadApp } from 'common/components/download-app/download-app';
import { TrackService } from 'common/services';
import { DepositFunnelEventNames } from 'common/types/services';

import NewDownloadApp from '../download-app/new-download-app';

type TCompletedProps = {
  title: string;
  newDownload?: boolean;
  titleDownload?: string;
};

const Completed: FC<TCompletedProps> = ({
  title,
  newDownload = false,
  titleDownload,
  children,
}) => {
  TrackService.trackEvent(DepositFunnelEventNames.flowCompleted);

  return (
    <SuccessWrapper title={title}>
      {children}

      {newDownload ? (
        <NewDownloadApp title={titleDownload} />
      ) : (
        <DownloadApp title={titleDownload} />
      )}
    </SuccessWrapper>
  );
};

export default Completed;
